module.exports = __webpack_public_path__ + "media/store/fonts/ft-menu-2-0b8d96a8caaf0799b6e50bf1dc1a9941.woff";